interface LogoProps {
  size?: "sm" | "md" | "lg";
  className?: string;
}

const SIZE_CLASSES = {
  sm: "h-9 w-9",
  md: "h-10 w-10",
  lg: "h-12 w-12",
} as const;

export function Logo({ size = "md", className = "" }: LogoProps) {
  return (
    <img
      src="/logo.png"
      alt="EDLAB Foundation"
      className={[
        "shrink-0 rounded-lg object-contain shadow-[0_4px_9px_#155c5020]",
        SIZE_CLASSES[size],
        className,
      ].join(" ")}
    />
  );
}
